import type { Environment } from '@core';

export const environment: Environment = {
  production: true,
  baseUrl: 'https://service.yinlibovip.com/',
  apkUrl: `https://eliboo-hd2sh-release.oss-cn-shanghai.aliyuncs.com/app/%E6%88%91%E7%9A%84%E5%BC%95%E7%AB%8B%E6%92%AD.apk`,
  versionCode: 9,
  orderClientId: 'elibooWeb-app-client',
  ossBucket: 'eliboo-hd2sh-release', //bucket名称
  ossEndpoint: 'oss-cn-shanghai.aliyuncs.com', //地域节点
  workerSrc: '/assets/json/pdf.worker.js',
  taxApi: {
    baseUrl: 'https://service.yinlibovip.com/',
    channelApiBaseUrl: 'https://service.yinlibovip.com/',
    clientId: 'eliboo-app-client',
    clientSecret: '123456',
    ossBucket: 'yw-common', //bucket名称
    ossEndpoint: 'oss-cn-shanghai.aliyuncs.com',
    versionCode: 20,
    uploadPlatform: 'eliboo',
    h5PayBasePath: 'https://business.yinlibovip.com/#/eliboo-pay',
  },
  noPhoneChannel: [27],
};
